// extracted by mini-css-extract-plugin
module.exports = {"type":"FileBrowserRow-type-sx-ns TableRowCell-cell-2fbg4"};